// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import React, { FC, useState } from "react";

type HoverComponentProps = {
    timer?: number;
    timerOut?: number;
    action: (isHover: boolean) => void;
    onMouseEnter?: () => {};
    onMouseLeave?: () => {};
    [key: string]: any;
};

const HoverComponent: FC<HoverComponentProps> = props => {
    const [state, setState] = useState<"enter" | "leave">("leave");
    let timerId: any;

    const {
        timer,
        timerOut,
        action,
        onMouseEnter: onMouseEnterProps,
        onMouseLeave: onMouseLeaveProps,
        children,
        ...componentProps
    } = props;

    const clearTimer = () => {
        if (timerId) {
            clearTimeout(timerId);
        }
    };

    const onMouseEnterHandler = () => {
        clearTimer();

        if (state === "enter") {
            return;
        }
        timerId = setTimeout(() => {
            setState("enter");
            action(true);
        }, timer);

        onMouseEnterProps && onMouseEnterProps();
    };

    const onMouseLeaveHandler = () => {
        clearTimer();
        if (state === "leave") {
            return;
        }

        const timerValue = timerOut || timer;

        timerId = setTimeout(() => {
            setState("leave");
            action(false);
        }, timerValue);

        onMouseLeaveProps && onMouseLeaveProps();
    };

    return (
        <StyledWrapper {...componentProps} onMouseEnter={onMouseEnterHandler} onMouseLeave={onMouseLeaveHandler}>
            {children}
        </StyledWrapper>
    );
};

HoverComponent.defaultProps = {
    timer: 350,
};

export default HoverComponent;
